/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { FindOptions } from './common';
import { entityService } from './services';

const pathname = '/entity-diaries';

export const EntityDiaryApi = {
  filter: async (options: FilterEntityDiaryOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(options);
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityDiaryByEntitySection: async (
    entitySectionID: string,
    options: FindEntityDiaryByEntitySectionOptions
  ) => {
    let url = `${pathname}/entity-section/${entitySectionID}`;
    const query = serialize(options);
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindEntityDiaryByEntitySectionOptions extends FindOptions {
  stepID?: string;
  distanceDate?: number;
}

export interface FilterEntityDiaryOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entitySectionID?: string;
  entityID?: string;
  stepID?: string;
  status?: number;
}
